<template>
  <v-tabs background-color="grey lighten-3" v-model="enquiryTab">
    <v-tabs-slider color="accent"></v-tabs-slider>
    <v-tab>Active</v-tab>
    <v-tab>Funded</v-tab>
    <v-tab>Inactive</v-tab>
    <v-tabs-items class="mt-0" v-model="enquiryTab">
      <v-tab-item class="mt-2 px-3" :class="{ 'funder-view': funderView }">
        <v-card class="enquiry-list" flat>
          <v-subheader v-if="activeEnquiries.length === 0">No active enquiries</v-subheader>
          <v-flex xs12 md8 lg6>
            <enquiry-list-tile
              v-for="enquiry in activeEnquiries"
              :enquiry="enquiry"
              :key="enquiry.id"
              :funderView="funderView"
            ></enquiry-list-tile>
          </v-flex>
        </v-card>
      </v-tab-item>
      <v-tab-item class="px-3" :class="{ 'funder-view': funderView }">
        <v-card class="enquiry-list" flat>
          <v-subheader v-if="fundedEnquiries.length === 0">No funded enquiries</v-subheader>
          <v-flex xs12 md8 lg6>
            <enquiry-list-tile
              v-for="enquiry in fundedEnquiries"
              :enquiry="enquiry"
              :key="enquiry.id"
              :funderView="funderView"
            ></enquiry-list-tile>
          </v-flex>
        </v-card>
      </v-tab-item>
      <v-tab-item class="px-3" :class="{ 'funder-view': funderView }">
        <v-card class="enquiry-list" flat>
          <v-subheader v-if="inactiveEnquiries.length === 0">No inactive enquiries</v-subheader>
          <v-flex xs12 md8 lg6>
            <enquiry-list-tile
              v-for="enquiry in inactiveEnquiries"
              :enquiry="enquiry"
              :key="enquiry.id"
              :funderView="funderView"
            ></enquiry-list-tile>
          </v-flex>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-tabs>
</template>

<script>
import _ from 'lodash';
import EnquiryListTile from './EnquiryListTile';

export default {
  components: {
    EnquiryListTile
  },
  name: 'enquiry-list',
  props: ['enquiries', 'funderView'],
  data: () => ({
    showInactive: false,
    enquiryTab: 0
  }),
  computed: {
    activeEnquiries: function() {
      return _.filter(this.enquiries, enquiry => enquiry.state === 'Active');
    },
    fundedEnquiries: function() {
      return _.filter(this.enquiries, enquiry => enquiry.state === 'Funded');
    },
    inactiveEnquiries: function() {
      return _.filter(this.enquiries, enquiry => enquiry.state === 'Inactive');
    }
  }
};
</script>

<style lang="scss" scoped>
.enquiry-list {
  height: calc(100vh - 265px);
  max-height: calc(100vh - 265px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  &.funder-view {
    height: calc(100vh - 210px);
    max-height: calc(100vh - 210px);
  }
}
</style>
